<template>
  <modal
    class="modal"
    name="login-unauthorized-user"
    transition="pop-out"
    :width="modalWidth"
    :height="160"
    :adaptive="true"
    :clickToClose="false"
    @before-open="beforeOpen"
  >
    <div class="flex flex-column items-center justify-center w-100 h-100">
      <span class="mb-4 flex items-center flex-wrap justify-center mt4 dn f6 mx1 alignText">{{ $t("users.loginToUnauthorizedUser") }}</span>
      <div class="flex items-center flex-wrap justify-center">
        <div class="mt4 mx3">
          <button
            @click="goToLogin(true)"
            :disabled="disabled"
            class="w-100 block mv2 pointer btn dim b f6 fw3"
            :class="{ 'disabled': disabled }"
          >
            {{ $t("users.registration.register") }}
          </button>
        </div>

        <div class="mt4 mx3">
          <button
            @click="goToLogin(false)"
            :disabled="disabled"
            class="w-90 block mv2 pointer btn dim b f6 fw3"
            :class="{ 'disabled': disabled }"
          >
            {{ $t("users.cancelLoginToUnauthorizedUser") }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>


<script>
  import {mapActions, mapGetters} from 'vuex'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  const MODAL_WIDTH = 350

  export default {
    name: 'login-unauthorized-user',
    components: {
      ClipLoader
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '30px',
        disabled: false,
        isFirstEnter: false
      }
    },
    computed: {
      ...mapGetters('player', [
        'isShareTrack',
        'isUnauthorized'
      ])},
    methods: {
      ...mapActions('player', [
        'setIsShareTrack',
        'setPlaying',
        'setIsUnauthorized'
      ]),
      beforeOpen (event) {
        this.disabled = false
        if (!this.isFirstEnter) this.setPlaying(false)
        if (!this.isUnauthorized) this.setIsUnauthorized(true)
      },
      goToLogin (goToLoginFlag) {
        if (goToLoginFlag) {
          this.disabled = true
          if (this.isShareTrack) {
            localStorage.removeItem('shareTrackId')
            this.setIsShareTrack(false)
          }
          if (this.isUnauthorized) this.setIsUnauthorized(false)
          this.$modal.hide('login-unauthorized-user')
          this.$auth0.loginWithRedirect()
        } else {
          if (!this.isFirstEnter) this.isFirstEnter = true
          this.$modal.hide('login-unauthorized-user')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .mx3 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx1 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .alignText {
    text-align: center !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/modals/login/LoginUnauthorizedUser.vue